exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".list-item{padding:15px 10px}.post-title{font-size:16px;color:#333}.comment-link{color:inherit}.comment-link:hover{color:#4dba87}", "", {"version":3,"sources":["/Users/grofers/mygithub/hnpwa-vue/src/components/PostsList.vue"],"names":[],"mappings":"AACA,WACE,iBAAmB,CACpB,AACD,YACE,eAAgB,AAChB,UAAY,CACb,AACD,cACE,aAAe,CAChB,AACD,oBACE,aAAe,CAChB","file":"PostsList.vue","sourcesContent":["\n.list-item {\n  padding: 15px 10px;\n}\n.post-title {\n  font-size: 16px;\n  color: #333;\n}\n.comment-link {\n  color: inherit;\n}\n.comment-link:hover {\n  color: #4dba87;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24b31533","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PostsList.vue
// module id = 24
// module chunks = 0